//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {api_getCommissionList, api_withdrawCommission} from "../../../api";
	import {conversion} from "../../../tool";

	export default {
		data(){
		    return {
				commissionData: {
					data: { list: [] },
					current: 1,
					size: 15
				},
            }
        },
        methods: {
			//翻页接口
			getuserCommission(obj) {
				api_getCommissionList(obj).then(res => {
					if (res.data.code === 0) {
						this.commissionData.data.list = res.data.data.data;
						this.commissionData.data.total = res.data.data.totalItems;
					}
				});
			},
			//翻页
			pageF(v) {
				this.getuserCommission({ page: v, size: this.commissionData.size });
			},

			//领取
			withdraw(obj) {
				api_withdrawCommission(obj).then(res => {
					if (res.data.code === 0) {
						this.$toast.info("领取成功");
						this.getuserCommission({page:1, size:15});
					} else {
						if (res.data.msg) {
							this.$toast.error(res.data.msg);
						} else {
							this.$toast.error("领取失败");
						}
					}
				});
			}
        },

        created() {
			this.getuserCommission({
				page: this.commissionData.current,
				size: this.commissionData.size
			});
		},
		name: "walletHistory"
	}
